

/**
 * @ngdoc service
 * @name app.DisplayUpload
 * @description
 * # DisplayUpload service
 */
angular.module('app')
	.service('DisplayUpload', /* @ngInject */ function ($timeout) {
		let
			_isDoc,
			_create,
			_uploaded = false,
			_preUpload = false,
			_loaded = false;
		const init = function (isDoc, create) {
			_isDoc = isDoc;
			_create = create;
		};

		const loaded = function () {
			_loaded = true;
		};

		const preUpload = function () {
			$timeout(function () {
				_preUpload = true;
			});
		};

		const upload = function () {
			_uploaded = true;
			_preUpload = false;
		};

		const setCreate = function (create) {
			_create = create;
		};

		const setIsDoc = function (isDoc) {
			_isDoc = isDoc;
		};

		// l'ajout de fichier apparait en mode creation
		// tant que je n'ai rien uploadé
		// et si le noeud n'est pas associé à un document.
		const displayUploadButton = function () {
			if (!_loaded || angular.isUndefined(_isDoc) || angular.isUndefined(_create)) {
				return false;
			}

			if (_create && !_isDoc) {
				return !_uploaded && !_preUpload;
			}
			else {
				return false;
			}
		};

		const displayUploadForm = function () {
			if (!_loaded || angular.isUndefined(_isDoc) || angular.isUndefined(_create)) {
				return false;
			}

			// cas le plus basique
			//console.log( 'is doc', _isDoc, 'create', _create );
			if (_isDoc && _create) {
				//console.log( 'not uploaded' , !_uploaded );
				return !_uploaded;
			}
			else if (_isDoc && !_create) {
				return !_uploaded && _preUpload;
			}
			else if (!_isDoc) {
				return !_uploaded && _preUpload;
			}
		};

		const displayForm = function () {
			if (!_loaded || angular.isUndefined(_isDoc) || angular.isUndefined(_create)) {
				return false;
			}

			if (_isDoc && _create) {
				return _uploaded;
			}
			else if (_isDoc && _create) {
				return _uploaded && !_preUpload;
			}

			return !_preUpload;
		};

		const displayCancel = function () {
			if (!_loaded || angular.isUndefined(_isDoc) || angular.isUndefined(_create)) {
				return false;
			}
			if (_isDoc) {
				return false;
			}
			else {
				return _preUpload;
			}
		};

		const cancel = function () {
			_preUpload = false;
		};

		// le mode replace apparait si
		// je suis en mode edition
		const displayReplace = function () {
			return !_create;
		};

		const resetUpload = function () {
			_preUpload = false;
			_uploaded = false;
			_loaded = false;
		};

		return {
			init:                init,
			loaded:              loaded,
			preUpload:           preUpload,
			upload:              upload,
			cancel:              cancel,
			setCreate:           setCreate,
			setIsDoc:            setIsDoc,
			displayUploadButton: displayUploadButton,
			displayUploadForm:   displayUploadForm,
			displayForm:         displayForm,
			displayReplace:      displayReplace,
			displayCancel:       displayCancel,
			resetUpload:         resetUpload,
		};
	});
